import * as React from "react";
import {Route, Switch} from "react-router-dom";
import {history} from "load/store";
import EligibilityPage from "loan-application/eligibilityPage";
import ApplicationIndex from "loan-application/application";
import LoanProducts from "loan-application/products";
export let indexPath = null;

export enum routePaths {
    ELIGIBILITY_PAGE = "",
    APPLICATION = "/application-field",
    PRODUCT = "/product",
}

export function getRoutes(path: string) {
    return (
        <Switch>
            <Route exact path={`${path}${routePaths.PRODUCT}`} component={LoanProducts}/>
            <Route exact path={`${path}${routePaths.ELIGIBILITY_PAGE}`} component={EligibilityPage}/>
            <Route path={`${path}${routePaths.APPLICATION}`} component={ApplicationIndex}/>
        </Switch>
    );
}

export function setIndexPath(path: string) {
    indexPath = path;
}
export function handleNavigation(navigateToPath: string) {
    if (indexPath) {
        history.push({pathname: `${indexPath}${navigateToPath}`});
    }
}
